import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NzCardComponent } from 'ng-zorro-antd/card';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  ComponentNameTranslationPipe,
  LevelNameTranslationPipe,
  MWhFormatterPipe,
  StorageLevelToCustomerLevelNamePipe,
} from '@twaice-fe/frontend/shared/services';
import { Recommendation, StorageLevel, StorageLevelV2 } from '@twaice-fe/shared/models';

@Component({
  selector: 'twaice-fe-balancing-recommendation',
  templateUrl: './balancing-recommendation.component.html',
  imports: [
    CommonModule,
    NzCardComponent,
    MWhFormatterPipe,
    LevelNameTranslationPipe,
    StorageLevelToCustomerLevelNamePipe,
    ComponentNameTranslationPipe,
  ],
  styleUrl: './balancing-recommendation.component.scss',
})
export class BalancingRecommendationComponent {
  @Input() recoverableEnergy: number | null;
  @Input() componentBk: string;
  @Input() enclosureBk: string | null;
  @Input() hasSiblingEffect = false;

  @Input() quickFixBufferPercent: number;
  @Input() recommendation: Recommendation | null;

  protected readonly storageLevel = StorageLevel;
  protected readonly storageLevelV2 = StorageLevelV2;
  protected readonly Recommendation = Recommendation; // eslint-disable-line @typescript-eslint/naming-convention
}
